module.exports = __webpack_public_path__ + "static/media/sample_passport.10310edc.jpg";